

















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Question from "../Question/Question";
import Loader from "../Loader.vue";

@Component({
    components: {Loader}
})
export default class QuestionCmpt extends Vue {
    @Prop({type: Number, required: true, default: 0}) private questionIndex!: number;
    @Prop({type: Object, required: true}) private question!: Question;
    @Prop({type: Boolean, default: true}) private showInfo!: boolean;
    @Prop({type: Boolean, default: true}) private showHint!: boolean;
    @Prop({type: Boolean, default: true}) private selectable!: boolean;
    @Prop({type: Boolean, default: false}) private result!: boolean;

    public isImgLoaded: boolean = false;
    public hightlight: number = -1;


    @Watch("imgSrc")
    changeImg(newVal: string, oldVal: string) {
        this.isImgLoaded = false;
    }

    imgLoaded() {
        this.isImgLoaded = true;
    }

    get imgSrc(): string {
        // console.log(`img of ${this.question.title}`, this.question.img);
        return this.question && this.question.img ? this.question.img : "/blank.jpg";
    }

    getQuestionAnswerClass(index: number, question: Question): string {
        let out: string = "";

        if (this.showInfo && question.answered !== null) {
            if (question.answered === index) {
                out = question.status === true ? "bg-success text-white" : "bg-danger text-white";
            } else if (question.answered !== index && this.question.answerNum === index) {
                out = "bg-success text-white";
            }
        }

        if (index === this.hightlight) {
            out += " hover ";
        }

        return out;
    }

    selectAnswer(index: number) {
        if (this.selectable && this.question.status === null && this.isImgLoaded) {
            this.question.status = index === this.question.answerNum;
            this.question.answered = index;

            this.hightlightAnswer(index);

            setTimeout(() => {
                this.$emit("selectAnswer");
            }, 500);
        }
    }

    hightlightAnswer(index: number) {
        this.hightlight = index;
        setTimeout(() => {
            this.hightlight = -1;
        }, 500);

    }
}
